var amdi18n={"__root":{"back":"Back"},"__cs":{"back":"Zpět"},"__da":{"back":"Tilbage"},"__de":{"back":"Zurück"},"__es":{"back":"Atrás"},"__fi":{"back":"Edellinen"},"__fr":{"back":"Précédent"},"__hr":{"back":"Natrag"},"__hu":{"back":"Vissza"},"__it":{"back":"Indietro"},"__ja":{"back":"戻る"},"__kk":{"back":"Артқа"},"__ko":{"back":"이전"},"__nb":{"back":"Tilbake"},"__nl":{"back":"Terug"},"__no":{"back":"Tilbake"},"__pl":{"back":"Wstecz"},"__pt":{"back":"Voltar"},"__pt-br":{"back":"Voltar"},"__ro":{"back":"Înapoi"},"__ru":{"back":"Назад"},"__sl":{"back":"Nazaj"},"__sv":{"back":"Föregående"},"__th":{"back":"ย้อนกลับ"},"__tr":{"back":"Geri"},"__zh":{"back":"后退"},"__zh-cn":{"back":"后退"},"__zh-hk":{"back":"上一步"},"__zh-mo":{"back":"上一步"},"__zh-sg":{"back":"后退"},"__zh-tw":{"back":"上一步"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;